import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { navigateHeader } from '@tiendanube/nexo/helpers';
import nexo from '../../nexoClient';
import { Layout, Page } from '@nimbus-ds/patterns';
import {
  Box,
  Button,
  Card,
  Table,
  Title,
  Text,
  useToast,
  Tag,
} from '@nimbus-ds/components';
import axiosInstance from '../../axios';
import { useLocation } from 'react-router-dom';

const CustomerPage: React.FC = () => {
  //const [rejectedSellers, setRejectedSellers] = useState<Seller[]>([]);
  const { tn_id } = useParams<{ tn_id: string }>();
  const { addToast } = useToast();
  const location = useLocation();
  const [isRemoveProductDisabled, setRemoveProductDisabled] = useState(false);
  const [customerData, setCustomerData] = useState<Customer>();
  const [appStatus, setAppStatus] = useState<string>();
  const [productStatus, setProductStatus] = useState<string>();
  const [productsSync, setProductsSync] = useState<string>();

  interface Customer {
    active: boolean;
    approved: boolean;
    approved_at: string | null;
    billing_address: string | null;
    billing_city: string | null;
    billing_country: string | null;
    billing_floor: string | null;
    billing_locality: string | null;
    billing_number: string | null;
    billing_province: string | null;
    billing_zipcode: string | null;
    created_at: string | null;
    email: string | null;
    id: number;
    identification: string | null;
    last_order_id: number | null;
    name: string | null;
    phone: string | null;
    tn_created_at: string | null;
  }

  useEffect(() => {
    navigateHeader(nexo, { goTo: '/', text: 'Volver al inicio' });
  }, []);

  //getListOfRejectedSellers();
  /*
  useEffect(() => {
    console.log(location.search);
    if (location.search && location.search.includes('?')) {
      console.log('includes!');
      const store = location.search.replace('?', '');
      console.log('store : ', store);
      if (!isNaN(parseInt(store))) {
        getSellerData(parseInt(store));
        console.log('getting for store ' + store);
      }
    }
  }, []);
  */

  /*
  const getSellerData = async (store_id: number) => {
    await axiosInstance
      .get('/seller_data', {
        params: {
          store_id: store_id,
        },
      })
      .then((response) => {
        setSellerData(response?.data?.seller);
        setAppStatus(response?.data?.app_status);
        setProductStatus(response?.data?.product_status);
        setProductsSync(response?.data?.products_sync);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  */

  /*
  const removeProductsUninstalledSeller = async (store_id: any) => {
    console.log('remove product uninstalled seller store id : ' + store_id);
    if (store_id) {
      setRemoveProductDisabled(true);
      await axiosInstance
        .post('/remove_seller_products', {
          store_id: store_id,
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == true) {
            addToast({
              id: 'remove-seller-products-success',
              type: 'success',
              text: 'Productos eliminados!',
              duration: 4000,
            });
          }
        })
        .catch((e) => {
          addToast({
            id: 'remove-seller-products-fail',
            type: 'danger',
            text:
              e.response.data?.message ??
              'Error al tratar de remover productos',
            duration: 4000,
          });
          console.log(e);
        });
    } else {
      addToast({
        id: 'remove-seller-products-fail-2',
        type: 'danger',
        text: 'No se han podido borrar los productos. No se ha encontrado seller en la lista',
        duration: 4000,
      });
    }
    return;
  };
  */

  /*
  const uninstallAndremoveProductsSeller = async (store_id: any) => {
    console.log('uninstall & remove product seller store id : ' + store_id);
    if (store_id) {
      setRemoveProductDisabled(true);
      await axiosInstance
        .post('/uninstall_seller', {
          store_id: store_id,
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == true) {
            addToast({
              id: 'uninstall-seller-success',
              type: 'success',
              text: 'Seller desinstalado',
              duration: 4000,
            });
          }
        })
        .catch((e) => {
          addToast({
            id: 'uninstall-seller-fail',
            type: 'danger',
            text:
              e.response.data?.message ??
              'Error al tratar de eliminar el seller',
            duration: 4000,
          });
          console.log(e);
        });
    } else {
      addToast({
        id: 'uninstall-seller-fail-2',
        type: 'danger',
        text: 'No se ha podido eliminar el seller. Seller no encontrado.',
        duration: 4000,
      });
    }
    return;
  };
  */

  useEffect(() => {
    console.log('CustomerPage mounted with tn_id:', tn_id);
    if (tn_id) {
      fetchCustomerData(tn_id);
    }
  }, [tn_id]);

  const fetchCustomerData = async (id: string) => {
    try {
      console.log('Fetching customer data for ID:', id);
      const response = await axiosInstance.get('/customer_data', {
        params: { tn_id: id },
      });
      console.log('Customer data response:', response.data);
      setCustomerData(response.data?.customer);
    } catch (error) {
      console.error('Error al obtener datos del cliente', error);
    }
  };

  //if (!customerData) return <div>Cargando datos del cliente...</div>;

  return (
    <Page maxWidth="1500px" marginTop="18">
      <Page.Header alignItems="center" title="Información de cliente" />
      <Page.Body>
        <Card>
          <Layout columns="2 - symmetric">
            <Layout.Section>
              <Box display="flex" flexDirection="column" gap="4" padding="4">
                <Text>
                  <strong>Estado:</strong>
                  {customerData?.approved ? ' ACTIVO' : ' INACTIVO'}
                </Text>
                <Text>
                  <strong>Nombre:</strong> {customerData?.name}
                </Text>
                <Text>
                  <strong>Email:</strong> {customerData?.email}
                </Text>
                <Text>
                  <strong>DNI/CUIT:</strong> {customerData?.identification}
                </Text>
                <Text>
                  <strong>Teléfono:</strong> {customerData?.phone}
                </Text>
                <Text>
                  <strong>Fecha creación:</strong>{' '}
                  {customerData?.tn_created_at || 'N/A'}
                </Text>
                <Text>
                  <strong>Fecha aprobado:</strong>{' '}
                  {customerData?.approved_at || 'N/A'}
                </Text>
                <Text>
                  <strong>Ultima orden:</strong>{' '}
                  {customerData?.last_order_id || 'N/A'}
                </Text>
              </Box>
            </Layout.Section>
            <Layout.Section>
              <Box display="flex" flexDirection="column" gap="4" padding="4">
                <Text>
                  <strong>Pais:</strong>{' '}
                  {customerData?.billing_country || 'N/A'}
                </Text>
                <Text>
                  <strong>Provincia:</strong>{' '}
                  {customerData?.billing_province || 'N/A'}
                </Text>
                <Text>
                  <strong>Ciudad:</strong> {customerData?.billing_city || 'N/A'}
                </Text>
                <Text>
                  <strong>Localidad:</strong>{' '}
                  {customerData?.billing_locality || 'N/A'}
                </Text>
                <Text>
                  <strong>Código postal:</strong>{' '}
                  {customerData?.billing_zipcode || 'N/A'}
                </Text>
                <Text>
                  <strong>Dirección:</strong>{' '}
                  {customerData?.billing_address || 'N/A'}
                </Text>
                <Text>
                  <strong>Número:</strong>{' '}
                  {customerData?.billing_number || 'N/A'}
                </Text>
                <Text>
                  <strong>Piso:</strong> {customerData?.billing_floor || 'N/A'}
                </Text>
              </Box>
            </Layout.Section>
          </Layout>
        </Card>
      </Page.Body>
    </Page>
  );
};

export default CustomerPage;
